import React, { useEffect, useRef, useState, useContext } from "react";
import { ThemeContext } from "../../hooks/ThemeContext";

const Testimonials = ({ messages: propMessages }) => {
  const defaults = [
    { author: "Grace Vsnyne", handle: "TechLife", text: "Mon business, mon explosion !" },
    { author: "Paul M.", handle: "paul_dev", text: "Super accompagnement — serveur rapide et fiable." },
    { author: "Ines R.", handle: "ines.crea", text: "Design pro, conversion en hausse." },
    { author: "Samir K.", handle: "samir_k", text: "TikTok a décollé, belle stratégie." },
    { author: "Léa D.", handle: "lea_marketing", text: "Contenu créatif et régulier, très efficace." },
    { author: "Olivier T.", handle: "oliviert", text: "Support réactif et hébergement sécurisé." },
    { author: "Extra", handle: "extra", text: "Message supplémentaire si nécessaire." },
  ];

  const { theme } = useContext(ThemeContext);
  const messages = (propMessages && propMessages.length ? propMessages : defaults).slice(-6);

  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages.length]);

  const startAutoplay = () => {
    stopAutoplay();
    intervalRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % messages.length);
    }, 4000);
  };

  const stopAutoplay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  return (
    <section className="py-6" aria-label="Témoignages">
      <div
        ref={containerRef}
        onMouseEnter={stopAutoplay}
        onMouseLeave={startAutoplay}
        className={`relative w-full max-w-7xl mx-auto px-4`}
      >
        <div className={`w-full ${theme === 'dark' ? 'bg-[#0b0b0c]/80 border border-white/8' : 'bg-white/95 border border-gray-100'} backdrop-blur-md rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center md:items-start gap-6 shadow-lg transition relative`}>
          <img
            src="/assets/images/avatar-placeholder.png"
            alt={messages[index].author}
            className="w-16 h-16 rounded-full object-cover flex-shrink-0"
          />

          <div className="flex-1 w-full">
            <p className={`text-lg md:text-xl font-medium transition-opacity duration-300 ${theme === 'dark' ? 'text-white' : 'text-gray-800'}`}>
              “{messages[index].text}”
            </p>
            <div className="mt-3 text-sm flex items-center gap-3">
              <span className={`font-semibold ${theme === 'dark' ? 'text-white' : 'text-gray-800'}`}>{messages[index].author}</span>
              <span className={`${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>@{messages[index].handle}</span>
            </div>
          </div>

          {/* Dots intégrés dans le cadre - alignés horizontalement (mobile center / desktop right) */}
          <div className="mt-4 md:mt-0 md:ml-4 w-full md:w-auto flex justify-center md:justify-end gap-2 md:gap-3">
            {messages.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                aria-label={`Aller au témoignage ${i + 1}`}
                className={`w-3.5 h-3.5 rounded-full transition-colors ${
                  i === index ? (theme === 'dark' ? 'bg-rose-500 shadow-lg' : 'bg-rose-600 shadow-lg') : (theme === 'dark' ? 'bg-white/30' : 'bg-gray-300')
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
